import LoggerHelper from "@/plugins/LoggerHelper";
import WebService from "@/plugins/WebService";
import { i18n } from "@/i18n.js";

export default class UtilityHelper {
  constructor(ctx) {
    this.ctx = ctx
  }

  getSprCode()
  {
    var selectedLanguage=this.ctx.$store.getters.selectedLanguage;
    if (selectedLanguage=="de")
      return 1;
    else if (selectedLanguage=="fr")
      return 2;
    else if (selectedLanguage=="en")
      return 4;
    else
      return 1;
  }

  getSprText()
  {
    var selectedLanguage=this.ctx.$store.getters.selectedLanguage;
    if (selectedLanguage=="de")
      return "Alle";
    else if (selectedLanguage=="fr")
      return "Tous";
    else if (selectedLanguage=="en")
      return "All";
    else
      return "Alle";
  }

  initPLParameters()
  {
    var plParameter = {
      sprcd: this.getSprCode(),
      produktReihe: "%",
      glanzgrad: "%",
      struktur: "%",
      innenAussen: "%",
      farbton: "%",
      kdnnr: 0,
      sapClientId: this.ctx.$store.getters.selectedSAPClient
    };
    this.ctx.$store.dispatch("setPLParameter", plParameter);
  }

  initComboBoxes()
  {
    this.ctx.$store.dispatch("setProduktReihe", "");
    this.ctx.$store.dispatch("setGlanzgrad", "");
    this.ctx.$store.dispatch("setStruktur", "");
    this.ctx.$store.dispatch("setInnenAussen", "");
    this.ctx.$store.dispatch("setFarbton", { farbton: "", farbtonBez: ""});
  }

  initPLItems()
  {
    var webService = new WebService(this.ctx);
    var myParameter = this.ctx.$store.getters.plParameter;
    myParameter.sprcd = this.getSprCode();

    LoggerHelper.logEvent(LoggerHelper.levelInfo, i18n.global.t("logging.readPowderCoatings"), myParameter);
    webService
      .getPLListByParameter(this.ctx.$store.getters.getPLByParameter,myParameter)
      .then(response => {
        LoggerHelper.logEvent(LoggerHelper.levelInfo, i18n.global.t("logging.readPowderCoatingsSuccess"), response.data);

        this.ctx.$store.dispatch(
          "setPLList",
          response.data.map((item, index) => ({
            id: index,
            ...item
          }))
        );
      })
      .catch(err => {
        LoggerHelper.logEvent(LoggerHelper.levelError, i18n.global.t("logging.readPowderCoatingsFailed"), err);
      });
  }

  rgbToHex(rgb) { 
    var hex = Number(rgb).toString(16);
    if (hex.length < 2) {
         hex = "0" + hex;
    }
    return hex;
  }

  fullColorHex(r,g,b) {
    var red = this.rgbToHex(r);
    var green = this.rgbToHex(g);
    var blue = this.rgbToHex(b);
    return red+green+blue;
  }

  getReadableForeColor(r,g,b)
  {
    return (((r+g+b)/3)>128) ? '000000' : 'ffffff';
  }

  setCustomerWarehouse()
  {
    var webService = new WebService(this.ctx);
    var plParameter = {
      sprcd: this.getSprCode(),
      produktReihe: "%",
      glanzgrad: "%",
      struktur: "%",
      innenAussen: "%",
      farbton: "%",
      kdnnr: this.ctx.$store.getters.user.kdnnr,
      sapClientId: this.ctx.$store.getters.selectedSAPClient
    };
    //no CustomerWarehouse in SAP
    if (this.ctx.$store.getters.isSAP)
      plParameter.farbton='select-no-data';

    LoggerHelper.logEvent(LoggerHelper.levelInfo, i18n.global.t("logging.readPowderCoatings"), plParameter);
    webService
    .getPLListByParameter(this.ctx.$store.getters.getPLByParameter,plParameter)
    .then(response => {
      LoggerHelper.logEvent(LoggerHelper.levelInfo, i18n.global.t("logging.readPowderCoatingsSuccess"), response.data);
      this.ctx.$store.dispatch("setCustomerWarehouse", response.data.length>0);
    })
    .catch(err => {
      LoggerHelper.logEvent(LoggerHelper.levelError, i18n.global.t("logging.readPowderCoatingsFailed"), err);
    });
  }

  showSystemWorksMessage() {
    /* const { hostname } = new URL(process.env.VUE_APP_URL);
    if (hostname=='www.kabe-farben.ch')
      return true;
    else
      return false; */
    return false;
  }  

}
